import React, { useMemo } from "react";
import useScrolledHeight from "../../hooks/useScrolledHeight";
import { useMediaQuery } from "react-responsive";
import { APP_NAME, isDesktopMediaQuery, isPerfX, LOGO_CDN_URL } from "../../constants/constants";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux-stores/store";
import { useDispatch } from "react-redux";
import { setCollabSupport } from "../../redux-stores/slices/layoutSlice";

interface HeaderProps {
    title?: string;
    showBackButton: boolean;
    menuToggleHandler?: () => void;
}

const Header: React.FC<HeaderProps> = ({
    title,
    menuToggleHandler,
}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();

    const { campaignId } = useParams();

    const collabSupport = useSelector((state: RootState) => state.layout.collabSupport);
    const collabSupportIcon = collabSupport.visibility.icon;

    const isCampaignPage = /^\/campaign\/[a-f0-9-]+$/.test(location.pathname);
    const isCollaborationMilestonePage = /^\/collaborations\/[a-f0-9-]+\/milestone\/\d+$/.test(location.pathname);
    const isCollaborationPage = /^\/collaborations\/[a-f0-9-]+$/.test(location.pathname);
    const isSocialAccountPage = /^\/i\/social-account\/[a-f0-9-]+$/.test(location.pathname);
    const scrolledHeight = useScrolledHeight();
    const isDesktop = useMediaQuery(isDesktopMediaQuery);

    const isConversionCampaignPage = /^\/conversion\/[a-f0-9-]+$/.test(location.pathname)


    const isNestedPage = isCampaignPage || isConversionCampaignPage || isCollaborationMilestonePage || isCollaborationPage || isSocialAccountPage;

    const backButtonHandler = () => {
        const previousURL = isCampaignPage ? '/' : 
            (isConversionCampaignPage ? '/conversion' : 
                (isCollaborationMilestonePage ? `/collaborations/${campaignId}` : 
                    (isCollaborationPage ? `/applications` : 
                        (isSocialAccountPage ? `/i/me` : '/')
                    )
                )
            );
        navigate(previousURL);
    }

    return (
        <React.Fragment>
            {
                scrolledHeight > 0 &&
                <div className={`header header-fixed header-logo-center`} style={{ left: 'auto', right: 'auto', width: isDesktop ? '770px' : '100%' }}>
                    <span className="header-title " style={{ left: isDesktop ? `${isNestedPage ? '15%' : '12%'}` : `${isNestedPage ? '32%' : '22%'}` }}>
                        {title ? title : <img src={LOGO_CDN_URL} alt={`${APP_NAME}-logo`} className="mt-n2" height={isPerfX ? 35 : 25} />}
                    </span>
                    {
                        isNestedPage &&
                        <button
                            onClick={backButtonHandler}
                            className="header-icon header-icon-1"
                            aria-label="Back"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    }
                    {
                        collabSupportIcon ? (
                            <button style={{ right: "30px" }} className="header-icon me-2" onClick={() => {
                                dispatch(setCollabSupport({ visibility: { ...collabSupport.visibility, popup: true } }))
                            }}>
                                <i className="fas fa-phone"></i>
                            </button>
                        ) : (
                            <a href="https://api.whatsapp.com/send?phone=+919266391960&text=Hi, I need help." rel="noreferrer" style={{ right: "30px" }} target="_blank" className="header-icon me-2" data-menu="menu-main"><i className="fab fa-whatsapp"></i></a>
                        )
                    }
                    <button
                        onClick={menuToggleHandler}
                        className="header-icon header-icon-4"
                        aria-label="Menu"
                    >
                        <i className="fas fa-bars"></i>
                    </button>
                </div>
            }
            <div className="page-title page-title-fixed d-flex justify-content-between align-items-center" style={{ position: 'relative', marginBottom: '1rem' }}>
                <div className="d-flex justify-content-start align-items-center w-75">
                    {
                        isNestedPage &&
                        <button
                            onClick={backButtonHandler}
                            className="header-icon header-icon-1 page-title-icon me-0"
                            aria-label="Back"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    }
                    <h3 className={`w-100 text-truncate ${!isNestedPage ? 'mx-3' : ''} mb-0`} >{title ? title : <img src={LOGO_CDN_URL} alt={`${APP_NAME}-logo`} className="ms-1" height={isPerfX ? 40 : 35} />}</h3>
                </div>

                {/* <span className="page-title-icon shadow-xl bg-theme color-theme" data-menu="menu-share"><i className="fa fa-share-alt"></i></span>
                <ThemeToggler /> */}
                <div className="d-flex justify-content-end me-0 w-100">
                    {
                        collabSupportIcon ? (
                            <button className="page-title-icon shadow-xl bg-theme color-theme me-2" onClick={() => {
                                dispatch(setCollabSupport({ visibility: { ...collabSupport.visibility, popup: true } }))
                            }}>
                                <i className="fas fa-phone"></i>
                            </button>
                        ) : (
                            <a href="https://api.whatsapp.com/send?phone=+919266391960&text=Hi, I need help." target="_blank" rel="noreferrer" className="page-title-icon shadow-xl bg-theme color-theme me-2" data-menu="menu-main"><i className="fab fa-whatsapp"></i></a>
                        )
                    }
                    <span className="page-title-icon shadow-xl bg-theme color-theme" onClick={menuToggleHandler} data-menu="menu-main"><i className="fa fa-bars"></i></span>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Header;